import { Link as ExpoLink, type LinkProps } from 'expo-router'
import React from 'react'
import type { TextProps } from 'react-native'
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { Text as RNText } from 'react-native'
import { cn } from '~/lib/utils'

function Text({
  className,
  ...props
}: TextProps & {
  ref?: React.RefObject<RNText>
}) {
  return <RNText className={cn('font-normal text-foreground', className)} {...props} />
}

function Link({
  className,
  ...props
}: LinkProps & {
  ref?: React.RefObject<typeof ExpoLink>
}) {
  return <ExpoLink className={cn('font-normal text-foreground', className)} {...props} />
}

export { Text, Link }
